import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=64c496f9&scoped=true&"
import script from "./AppBar.vue?vue&type=script&lang=js&"
export * from "./AppBar.vue?vue&type=script&lang=js&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=64c496f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c496f9",
  null
  
)

export default component.exports